<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="hkiarace/admin/banner/"
                       data-key="banners"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template #item.from_time="{value}">
      {{ $parseDate(value, 'dd/MM/yyyy') }}
    </template>
    <template #item.to_time="{value}">
      {{ $parseDate(value, 'dd/MM/yyyy') }}
    </template>
    <template v-slot:item.actions="{item}">
      <v-row>
        <v-col>
          <font-awesome-icon icon="edit"
                             @click="editItem(item)"></font-awesome-icon>
        </v-col>
        <v-col>
          <font-awesome-icon icon="trash"
                             @click="deleteItem(item)"></font-awesome-icon>
        </v-col>
      </v-row>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import EditHkiaraceBannerModal from "@/components/hkiaraceBanner/EditHkiaraceBannerModal";

export default {
  name: 'HkiaraceBannerList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_banner.name'), value: 'name', contains: true},
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_banner.name'), value: 'name'},
      {text: root.$t('admin_banner.path'), value: 'path'},
      {text: root.$t('admin_banner.from_time'), value: 'from_time'},
      {text: root.$t('admin_banner.to_time'), value: 'to_time'},

      {text: '', value: 'actions', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = async function (item) {
      const needRefresh = await root.$dialog.showAndWait(EditHkiaraceBannerModal, {
        bannerId: item.id,
        showClose: false,
        persistent: true,
        scrollable: true,
        width: '95vw',
        height: '90vh',
      });

      if (needRefresh) {
        refresh();
      }
    };
    const deleteItem = function (item) {
      if (confirm('Confirm Delete Popup Banner?')) {
        root.$callAPI('hkiarace/admin/banner/delete/', {banner_id: item.id}, function () {
          refresh();
        })
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      deleteItem,
    }
  }
}
</script>
